<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center" col-spaced>
          <grid-col col-size="4">
            <h1 class="header margin-top-xl">
              {{ $t('menu.workspace') }}
            </h1>
          </grid-col>
        </grid-row>
        <grid-row column-align="center" class="margin-top-xxl">
          <grid-col col-size="4">
            <div class="center-horizontal">

              <!-- Dashboard -->
              <safe-router-link to="/dashboard" class="nav__menu-item">
                <div v-has-feature="'DashboardManagement'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.dashboard"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.dashboard') }}</div>
                </div>
              </safe-router-link>

              <!-- Events -->
              <safe-router-link to="/event/list">
                <div v-has-feature="'Rule'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.eventsIcon"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('events.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Rules -->
              <safe-router-link to="/rule/list" class="nav__menu-item">
                <div v-has-feature="'Rule'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.rulesIcon"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('rule.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Aggregate variables (menu / operated) -->
              <safe-router-link to="/aggregate-variable/menu" class="nav__menu-item">
                <div v-has-feature="'AggregateVariable'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.variablesIcon"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('aggregateVariable.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Queries -->
              <safe-router-link to="/query/list" class="nav__menu-item">
                <div v-has-feature="'Admin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.queriesIcon"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.queries') }}</div>
                </div>
              </safe-router-link>

              <!-- Raw variables  -->
              <safe-router-link to="/raw-variable/list" class="nav__menu-item">
                <div v-has-feature="'Admin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.rawVariablesIcon"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('rawVariable.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Variable Management -->
              <safe-router-link to="/variable-management" class="nav__menu-item">
                <div v-has-feature="'Admin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.variableManagement"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('variableManagement.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Nutritional Plan -->
              <safe-router-link to="/nutritionalPlan/menu" class="nav__menu-item">
                <div v-has-feature="'NutritionalPlan'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.salad"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.nutritionalPlan.menu') }}</div>
                </div>
              </safe-router-link>

              <!-- CSV -->
              <safe-router-link to="/csv-uploader" class="nav__menu-item">
                <div v-has-feature="'Superadmin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.csv"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.csvIngest') }}</div>
                </div>
              </safe-router-link>

              <!-- Food CSV -->
              <safe-router-link to="/csv-food-composition-uploader" class="nav__menu-item">
                <div v-has-feature="'NutriAdmin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.food"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.csvFoodCompositionIngest') }}</div>
                </div>
              </safe-router-link>

              <!-- Food Manager -->
              <safe-router-link to="/food-manager" class="nav__menu-item">
                <div v-has-feature="'FoodManager'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.fileManager"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.foodManager') }}</div>
                </div>
              </safe-router-link>

              <!-- Recipe -->
              <safe-router-link to="/recipe" class="nav__menu-item">
                <div v-has-feature="'ManageRecipes'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.recipe"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.recipe.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Recipe Tags -->
              <safe-router-link to="/recipe-tag" class="nav__menu-item">
                <div v-has-feature="'ManageRecipes'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.tags"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.recipe.tags') }}</div>
                </div>
              </safe-router-link>

              <!-- Performance -->
              <safe-router-link to="/performance/backoffice" class="nav__menu-item">
                <div v-has-feature="'Superadmin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.performance"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('windPower.performance') }}</div>
                </div>
              </safe-router-link>

              <!-- Cache management -->
              <safe-router-link to="/cache-management" class="nav__menu-item">
                <div v-has-feature="'Query'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.cogs"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('backoffice.cacheManagement') }}</div>
                </div>
              </safe-router-link>

              <!-- Gpx uploader -->
              <safe-router-link to="/gpx-uploader" class="nav__menu-item">
                <div v-has-feature="'Integration'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.gpx"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.gpxIngest') }}</div>
                </div>
              </safe-router-link>

              <!-- Integration -->
              <safe-router-link to="/integration" class="nav__menu-item">
                <div v-has-feature="'Integration'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.strava"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.integrate') }}</div>
                </div>
              </safe-router-link>

              <!-- GlucoseUploader -->
              <safe-router-link to="/glucoseUploader" class="nav__menu-item">
                <div v-has-feature="'Query'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.glucoseUploader"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.glucoseUploader') }}</div>
                </div>
              </safe-router-link>

              <!-- GlucoseUploader -->
              <safe-router-link to="/glucoseUploader" class="nav__menu-item">
                <div v-has-feature="'Query'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.superSapiens"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.superSapiens') }}</div>
                </div>
              </safe-router-link>

              <!-- Licenses -->
              <safe-router-link to="/licenseManagement" class="nav__menu-item">
                <div v-has-feature="'Admin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.licenseManagement"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('menu.licenseManagement') }}</div>
                </div>
              </safe-router-link>

              <!-- Challenges -->
              <safe-router-link to="/challenge-management" class="nav__menu-item">
                <div v-has-feature="'Superadmin'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.trophy"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.menu.challengeManagement') }}</div>
                </div>
              </safe-router-link>

              <!-- Explore recommendations -->
              <safe-router-link to="/explore-recommended-posts" class="nav__menu-item">
                <div v-has-feature="'ExploreRecommendedPostsUpdate'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.explore"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.exploreRecommendations.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Nutritionist note-->
              <safe-router-link to="/nutritionistNotes" class="nav__menu-item">
                <div v-has-feature="'NutriAdmin'" class="personal-area-element">
                  <font-awesome-icon
                        :icon="icons.nutriNotes"
                        class ="personal-area-element-icon"/>
                  <div class="personal-area-element-title">
                    {{ $t('health.NutritionistNotes.menu') }}
                  </div>
                </div>
              </safe-router-link>
            </div>

          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from './MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faBell,
  faCalculator,
  faCalculatorAlt,
  faEdit,
  faFileChartLine,
  faSlidersH,
  faUsers,
  faTags,
  faMoneyCheckEdit,
  faFileCsv,
  faWindTurbine,
  faSalad,
  faFileMedicalAlt,
  faUtensils,
  faRunning,
  faFilePlus,
  faAppleCrate,
  faFileCertificate,
  faTrophy,
  faGraduationCap,
  faFlask,
  faHatChef,
  faAnalytics,
  faClipboardList
} from '@fortawesome/pro-light-svg-icons';
import SafeRouterLink from '@/components/shared/SafeRouterLink';
import {faCogs} from '@fortawesome/pro-light-svg-icons/faCogs';
import {faFileCode} from '@fortawesome/pro-light-svg-icons/faFileCode';

export default {
  name: 'PersonalArea',
  components: {
    SafeRouterLink,
    MainLayout,
    GridRow,
    GridCol,
    FontAwesomeIcon
  },
  data () {
    return {
      icons: {
        eventsIcon: faBell,
        rulesIcon: faSlidersH,
        operatedVariablesIcon: faCalculatorAlt,
        variablesIcon: faCalculator,
        rawVariablesIcon: faEdit,
        queriesIcon: faFileChartLine,
        rolesAndPermissionsIcon: faUsers,
        tags: faTags,
        variableManagement: faMoneyCheckEdit,
        csv: faFileCsv,
        performance: faWindTurbine,
        food: faUtensils,
        cogs: faCogs,
        gpx: faFileCode,
        strava: faFilePlus,
        salad: faSalad,
        glucoseUploader: faFileMedicalAlt,
        superSapiens: faRunning,
        fileManager: faAppleCrate,
        licenseManagement: faFileCertificate,
        trophy: faTrophy,
        explore: faGraduationCap,
        test: faFlask,
        recipe: faHatChef,
        tag: faTags,
        dashboard: faAnalytics,
        nutriNotes: faClipboardList
      }
    };
  },
  computed: {
    getBreadcrumb () {
      const self = this.$t('menu.workspace');
      return [
        {name: self, link: '/workspace', disabled: true}
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../stylesheets/variables.scss";

  .personal-area-element {
    align-items: center;
    display: inline-block;
    vertical-align: top;
    text-align: center;
    background-color: $black-light9;
    border: solid 0.2rem $black-light9;
    border-radius: $radius;
    height: 15rem;
    width: 15rem;
    color: $secondary;
    margin: 1rem;
    padding-top: 2.7rem;
  }

  .align-center {
    align-items: center;
    display: inline-block;
    text-align: center;
  }

  .personal-area-element:hover {
    border: solid 0.2rem $black-light5;
  }

  .personal-area-element-icon {
    font-size: 7rem;
  }

  .personal-area-element-title {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .disabled, .disabled:hover{
    color: $secondary-trans7;
    border: solid 0.2rem $black-light9;
  }

  .center-horizontal {
    display: table;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/Workspace.vue